import { render } from "./SetServiceCost.vue?vue&type=template&id=4fa33d38"
import script from "./SetServiceCost.vue?vue&type=script&lang=js"
export * from "./SetServiceCost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__